import React from "react";

import Loading from "../../feedback/Loading";
import { useTheme } from "../../../hooks";

import { pageTransitionOverlayPropTypes } from "../../../propTypes";
import styles from "./PageTransitionOverlay.module.scss";

/**
 * PageTransitionOverlay component.
 * Displays a loading overlay that appears during page transitions.
 * The overlay can be shown or hidden based on the `active` prop.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.active=false] - Whether the overlay should be visible
 * @returns {React.ReactElement} The overlay element with loading indicator
 */
const PageTransitionOverlay = ({ active }) => {
  const theme = useTheme();

  return (
    <div
      className={`${styles.overlay} ${!active ? styles["overlay--hidden"] : ""}`}
      data-theme={theme}
      aria-hidden={!active}
    >
      <Loading />
    </div>
  );
};

PageTransitionOverlay.propTypes = pageTransitionOverlayPropTypes;

PageTransitionOverlay.defaultProps = {
  active: false,
};

export default PageTransitionOverlay;
